import useCatalogueData from "hook/useCatalogueData";
import "swiper/css";
import "swiper/css/navigation";
import SlideSwiperView from "components/commonComponent/slideSwiperView";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
const Catalogue = () => {
  const { catalogues, loadingCatalogue } = useCatalogueData();
  const {  language } = useSettings();
  return (
    <div className="mt-4">
      {catalogues?.length > 0 && (
        <SlideSwiperView
          data={catalogues}
          loading={loadingCatalogue}
          title={t("category", language)}
          slidesPerView={6}
          linkKey="catalogue_id"
          imageKey="image_path"
          textKey="title"
        />
      )}
    </div>
  );
};

export default Catalogue;
